import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  message: null, // Default is null to avoid unnecessary rendering
  type: 'info',  // Default type
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setAlert: (state, action) => {
      state.message = action.payload.message;
      state.type = action.payload.type || 'info';
    },
    clearAlert: (state) => {
      state.message = null;
      state.type = 'info';
    },
  },
});

export const { setAlert, clearAlert } = alertSlice.actions;
export default alertSlice.reducer;
